import Vue from 'vue';
import VueRouter from 'vue-router';
import routerConstants from '@/const/routerConstants';
import pageViews from './page';
import settingPageViews from './settingPage';
import appPageViews from './appPage';
import store from '@/store';
// import { callApp } from '@/utils/app/callApp.js';
// import { checkAuth } from '@/utils/auth/authUtil';
import { checkSecondAuthenticate } from '@/api/secondAuthenticate';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history', // URL의 #이 제거 된다.
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    // home
    {
      name: routerConstants.Main,
      path: '/main',
      meta: { bottomNav: true },
      component: () => import('@/views/home/MainView.vue'),
    },

    {
      name: 'appResponse',
      path: '/appResponse/:type',
      component: () => import('@/views/home/AppResponse.vue'),
    },

    {
      name: routerConstants.Calendar,
      path: '/calendar',
      meta: { bottomNav: true },
      component: () => import('@/views/etc/CalendarView.vue'),
    },
    {
      name: routerConstants.CalendarAppl,
      path: '/calendarAppl',
      meta: { bottomNav: true },
      component: () => import('@/views/etc/CalendarApplView.vue'),
    },
    {
      name: routerConstants.MemberSearch,
      path: '/memberSearch',
      meta: { bottomNav: true },
      component: () => import('@/views/etc/MemberSearchView.vue'),
    },
    {
      name: routerConstants.AllMenu,
      path: '/allMenu',
      meta: { bottomNav: true },
      component: () => import('@/views/etc/AllMenuView.vue'),
    },
    {
      path: '/setting',
      component: () => import('@/views/home/SettingPageView.vue'),
      children: settingPageViews,
    },
    {
      name: routerConstants.Page,
      path: '/page',
      meta: { bottomNav: true },
      component: () => import('@/views/home/PageView.vue'),
      children: pageViews,
    },
    {
      name: routerConstants.AppPage,
      path: '/appPage',
      component: () => import('@/views/home/AppPageView.vue'),
      children: appPageViews,
    },

    // error
    {
      name: routerConstants.Error,
      path: '/error',
      component: () => import('@/views/home/ErrorView.vue'),
      props: true,
    },

    // policy consent (앱최초 약관동의)
    {
      name: routerConstants.PolicyConsent,
      path: '/policyConsent',
      component: () => import('@/views/home/policy/PolicyConsentView.vue'),
    },
    {
      name: routerConstants.PolicyConsentService,
      path: '/policyConsent/service',
      component: () => import('@/views/home/policy/ServiceView.vue'),
    },
    {
      name: routerConstants.PolicyConsentPrivacy,
      path: '/policyConsent/privacy',
      component: () => import('@/views/home/policy/PrivacyView.vue'),
    },

    // login
    {
      name: routerConstants.Login,
      path: '/login',
      component: () => import('@/views/auth/LoginView.vue'),
    },

    // (!) dohee - publishing page
    // {
    //   name: 'publishingPages',
    //   path: '/publishing',
    //   component: () => import('@/views/home/PageView.vue'),
    //   children: dohee,
    // },

    {
      name: 'applPage',
      path: '/applPage',
      component: () => import('@/views/home/Application.vue'),
    },

    {
      name: 'applRest',
      path: '/applRest',
      component: () => import('@/views/home/ApplicationRest.vue'),
    },
    {
      name: 'applLoanList',
      path: '/applLoanList',
      component: () => import('@/views/home/ApplLoanList.vue'),
    },
    {
      name: 'applLoanDetail',
      path: '/applLoanDetail',
      component: () => import('@/views/home/ApplLoanDetail.vue'),
    },
    // {
    //   name: 'loginCer',
    //   path: '/loginCer',
    //   component: () => import('@/views/home/LoginCertification.vue'),
    // },
    {
      name: 'test',
      path: '/test',
      component: () =>
        import('@/components/application/viewer/VacationViewerData.vue'),
    },
    {
      name: 'rdTest',
      path: '/rdTest',
      component: () => import('@/views/test/rdTest.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  // /* 권한 체크 */
  // console.log('***********************router index***************************');
  // console.log('index router name : ' + to.name);
  // console.log('index NODE_ENV : ' + process.env.NODE_ENV);
  // console.log('index routerConstants : ' + JSON.stringify(routerConstants));
  // if (
  //   process.env.NODE_ENV === 'production' &&
  //   to.name !== 'appResponse' &&
  //   to.name !== routerConstants.Login &&
  //   to.name !== routerConstants.PolicyConsent &&
  //   to.name !== routerConstants.PolicyConsentService &&
  //   to.name !== routerConstants.PolicyConsentPrivacy &&
  //   to.name !== routerConstants.Error
  // ) {
  //   // const result = checkAuth();
  //   //if (!result) {
  //   //  return false;
  //   // }
  // }

  /* 앱 접근시 */
  //  로그인화면에서는 제외
  // const userAgent = window.navigator.userAgent.toLowerCase();
  // console.log('index userAgent : ', userAgent);
  // console.log('**************************************************************');
  // if (
  //   userAgent.indexOf('iphone') > -1 ||
  //   userAgent.indexOf('ipad') > -1 ||
  //   userAgent.indexOf('android') > -1
  // ) {
  //   // 급여페이지 접근 시 비밀번호 입력 호출
  //   if (to.path.indexOf('/paySta') !== -1) {
  //     //callApp.activateSecureScreen(to.path);
  //   } else {
  //     //callApp.inactivateSecureScreen(to.path);
  //   }
  // }

  console.log('from : ' + from.fullPath + ', to : ' + to.fullPath);

  //현재 페이지가 신청서 작성 페이지이고, 다음 페이지가 신청서 목록페이지인 경우(뒤로가기 눌러서 빠져나가는 경우)
  //컨펌창 띄우기
  if(checkApplFormPage(from.fullPath)){
    if(checkApplFormToPage(to.fullPath)){
      if(confirm('작성중인 신청서를 취소하시겠습니까? 작성한 내용은 사라집니다.')){
        next();
      }else{
        router.go(1);
      }
    }else{
      next();
    }
  }else{
    //급여명세서, 근로계약서, 연봉계약서, 전적동의서
    if (isSensitivePage(to.path) && !store.getters.GET_SECOND_AUTHENTICATE) {
      checkSecondAuthentication(to, next);
    } else {
      next();
    }
  }

});
//2차인증 필요한 페이지인지 체크
function isSensitivePage(path){
  let sensitivePageList = [
      '/laborContract'
      , '/consentContract'
      , '/annualContract'
      , '/selectPayGubun'
  ];
  for(let i=0; i<sensitivePageList.length; i++){
    if(path === sensitivePageList[i]) return true;
  }
  return false;
}
//다음 페이지가 신청서 목록 페이지인지 체크
function checkApplFormToPage(path){
  const pageList = [
      '/vacationGntGubunMenuView'
      //, '/workScheduleTime1' //시차출퇴근제 목록
      , '/workScheduleTimeView' //시차출퇴근제 기준일자 캘린더
      //, '/holReplaceApp' // 휴일사전대체 목록
      , '/dateHolReplaceAppView' // 휴일사전대체 휴일근무일자 캘린더
      //, '/leaAbsAppStep1' //휴복직 목록 
      , '/endDateAppl' //휴복직 종료일 캘린더
      , '/leaAbsBoxView'
      , '/edusApp'
      , '/vaccination'
      , '/reCertAppStep'
      , '/cancelMenu'
      , '/holReplaceBoxView'
  ];
  for(let i=0; i<pageList.length; i++){
    if(pageList[i] === path) return true;
  }
  return false;
}
//현재 페이지가 신청서 작성 페이지인지 체크
function checkApplFormPage(path){
  const pageList = [
    '/vacationView'
    , '/vacationCancelView'
    , '/workScheduleTime2' //시차출퇴근제 신청서
    , '/holReplaceSubView' //휴일사전대체 신청서
    , '/holReplaceCancelSubView'
    , '/leaAbsAppStep3' //휴복직 신청서 육아,가족돌봄
    , '/leaAbsAppEtcView' //휴복직 신청서 난임, 휴직연장, 공상휴직, 사상휴직, 신상휴직
    , '/leaAbsAppRehView' // 휴복직 신청서 복직
    , '/leaAbsAppParLeaveView' //육아휴직(연장)
    , '/leaAbsAppParLeaveAddView' //육아휴직(추가)
    , '/edusAppSub'
    , '/vaccinationSub'
    , '/reCertTenureAppView'
    , '/reCertTenureEngAppView'
    , '/reCertTenureTaxAppView'
    , '/reCertGabTaxView'
    , '/reCertLeaveAppView'
    , '/reCertTenureTaxAppView'
  ];

  for(let i=0; i<pageList.length; i++){
    if(pageList[i] === path) return true;
  }
  return false;
}

function checkSecondAuthentication(to, next) {
  checkSecondAuthenticate({
    enterCd: store.getters.GET_USER_DATA.ssnEnterCd,
    userId: store.getters.GET_USER_DATA.id,
    sessionToken: store.getters.GET_SESSION_TOKEN,
  })
    .then(response => {
      if(response.status !== 200) return;
      next();
    })
    .catch(err => {
      if (err.response.status === 401) {
        // router
        //   .replace({
        //     path: '/loginCer',
        //     query: { redirectUrl: to.path },
        //   })
        //   .catch(() => {});
        store.commit('SET_SECOND_AUTHENTICATE_AFTER_TYPE', 'page');
        store.commit('SET_REDIRECT_URL', to.path);
        store.commit('SET_SHOW_SECOND_AUTHENTICATE', true);
      }
    });
}

router.onError(error => {
  console.error('>>> router onError :: ', error);
  // const domainUrl = `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_FULL_BASE_URL}`;
  //
  // // ChunkLoadError
  // if (error.name === 'ChunkLoadError') {
  //   // alert('[error] ChunkLoadError');
  //   window.location.href = `${domainUrl}/main`; // 메인으로 이동
  // } else {
  //   window.location.href = `${domainUrl}/error`; // 에러페이지로 이동
  // }
});

export default router;
